import { combineReducers } from "redux";
import { all, fork } from "redux-saga/effects";
import { authReducer, AuthReducerState, authSaga } from "./auth";

export interface IApplicationState {
  auth: AuthReducerState;
}

export const rootReducer = combineReducers<IApplicationState>({
  auth: authReducer,
});

export function* rootSaga() {
  yield all([fork(authSaga)]);
}


export * from "./auth"